import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SpreadProfileAction } from '@cbridge-packages/spread-profile';

export const reloadSpreadProfileListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SpreadProfileAction.create.done,
    SpreadProfileAction.update.done,
    SpreadProfileAction.remove.done,
  ),
  map(() => {
    return SpreadProfileAction.loadList.started();
  }),
);
